
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()"><ion-icon slot="start" name="close"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <h1>Tische/Bodenfläche für Event bestellen</h1>
  <form id="accountForm" [formGroup]="deskOrderForm" (ngSubmit)="orderDesks()" novalidate>
    <ion-list>
      <ion-item>
        <ion-select label="Veranstaltung" labelPlacement="stacked" placeholder="Bitte Auswählen" [formControlName]="'event'" required>
          <ion-select-option *ngFor="let event of events" [value]="event">{{event.name}} {{event?.start | date :  "dd.MM.y"}} </ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-input label="Anzahl Tische" labelPlacement="stacked" type="number" autofocus="true"  name="amount_desks" formControlName="amount_desks"></ion-input>
      </ion-item>
      <ion-item>
        <ion-input label="Bodenfläche (m²)" labelPlacement="stacked" type="number" autofocus="true"  name="amount_squaremeters" formControlName="amount_squaremeters"></ion-input>
      </ion-item>

    </ion-list>
    <ion-button type="submit" size="block" [disabled]="!deskOrderForm.dirty || deskOrderForm.invalid">Tische/Bodenfläche bestellen</ion-button>
  </form>
</ion-content>
